import { createApiDescription } from "../../helperFunctions";

export const archivedSignatureInfo = {
    archivedSignature: createApiDescription(
        "This API can be called to get the list of Signature documents present in Archive Signatures with various filters applied in the request.",
        [
            "GET Archive Signatures API provide results based on the given filters on the request headers and if no filter values are given, it provides results based on default value mapped with all filters.",
            "The default number of Signature documents in the response will be 10.",
            "It will display the records with current tax year applied as a default filter similar to signature application."
        ]
    ),
    deleteSignature: createApiDescription(
        "This API can be called to delete archive signatures and move them to the recycle bin.",
        [
            "Delete Signature API will be used to delete the signature documents if only present in Archive Signatures report page.",
            "Delete Signature API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once request is sent from Delete Signature API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
    resendAccessLink: createApiDescription(
        "This API can be called to Resend the Access Link to a signature document based on a given client’s signer guid.",
        [
            "Resend Access Link API will be used to resend the access link to the users if the given signature document is present in Archive Signature report page.",
            "Resend Access Link API works only if the given Document’s signature status is applicable to send the access link with valid client’s guid and access link will not be sent for non applicable statuses.",
            "Client's signer guid is available in GET Signer Details API."
        ]
    ),
    restoreSignature: createApiDescription(
        "This API can be called to restore archived signature documents back to delivered signatures report page.",
        [
            "Restore Signature API will be used to move the signature documents if present in Archive Signature report page.",
            "Restore Signature API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once request is sent from Move to Delivered API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
    sendReminder: createApiDescription(
        "This API can be called to Send the Reminder Email to the Signers of archived signature documents.",
        [
            "Send Reminder API will be used to send the reminder to the users if only the given signature document is present in Archived Signature report page.",
            "Send Reminder API works only if the given document’s signature statuses are applicable and reminder will not be sent for the not applicable statuses."
        ]
    ),
    getSignerDetails: createApiDescription(
        "This API can be called to fetch the details of Signers for a given Signature document.",
        [
            "Get Signer Information API can be used to get Signer Details if the given signature document is present in Archive Signature report page."
        ]
    ),
    getAccessLink: createApiDescription(
        "This API can be used to fetch the access link for a Signature request document.",
        [
            "Returns the the access link that is received via email upon a delivered signature request.",
            "This API will return the link for all recipients."
        ]
    )
}